import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

export const Banner = styled(Row)`
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.success};
  width: 100%;
  height: 60px;
  padding: 20px;
`;
